module.exports = __webpack_public_path__ + "img/not-todo.df04f09f.png";